/* eslint-disable import/prefer-default-export */
export const STORAGE_KEY_ACCOUNT_LINK_REMINDER_NEVER_NAG = 'ACCOUNT_LINK_REMINDER_NEVER_NAG';